define('view/controller/booking/datetime/DateDefaultView',['require','view/controller/booking/datetime/BaseDateView','lib/view/BookingUrlBuilder','Config'],function (require) {

    var BaseDateView = require('view/controller/booking/datetime/BaseDateView');
    var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');
    var Config = require('Config');

    /**
     * Default date picker view
     *
     * @class DateDefaultView
     */
    return BaseDateView.extend({

        template: '#date_default_view',

        ui: {
            'nextMonthBtn': '#sb_next_month',
            'prevMonthBtn': '#sb_prev_month',
            'availableDate': '.sb-available-date'
        },
        triggers: {
            'click @ui.nextMonthBtn': 'nextMonth',
            'click @ui.prevMonthBtn': 'prevMonth',
        },
        events: {
            'click @ui.availableDate': 'changeDate',
        },

        serializeData: function () {
            var result = BaseDateView.prototype.serializeData.apply(this);

            var days = this.getOption('collection').getDays(this.getTimeDiff());
            var date = new Date();
            var dateStr = date.getMysqlDate();

            result.week_days = date.getWeekDaysList('medium', true);
            result.weekends = [0, 6];
            if (Config.getInstance().isMondayFirstDay()) {
                result.weekends = [5, 6];
            }

            for (var i = 0; i < days.length; i++) {
                var dayDate = Date.parseMysqlDate(days[i].date);
                var mondayIsFirstDay = Config.getInstance().isMondayFirstDay();

                if ((mondayIsFirstDay && dayDate.getDay() === 1) || (!mondayIsFirstDay && dayDate.getDay() === 0)) {
                    days[i].is_first_day = true;
                }
                if ((mondayIsFirstDay && dayDate.getDay() === 0) || (!mondayIsFirstDay && dayDate.getDay() === 6)) {
                    days[i].is_last_day = true;
                }
                if (_.indexOf(this._dates, days[i].date) > -1) {
                    days[i].selected = true;
                }
                if (days[i].date === dateStr) {
                    days[i].today = true;
                }
                days[i].is_current_month = dayDate.getMonth() === this._currentMonth;
            }

            if (this._dates.length > 1) {
                result.week_mode = true;
            }

            result.days = days;
            result.current_year = this._currentYear;
            result.current_month = this._currentMonth;

            return result;
        },

        setSelectedDates: function (dates) {
            BaseDateView.prototype.setSelectedDates.apply(this, [dates]);

            if (!this.isDestroyed) {
                this.render();
            }
        },
        
        changeDate: function (event) {
            this._updateDate($(event.target).data('date'));
            
            return false;
        },
        
        _updateDate: function (date) {
            var url = BookingUrlBuilder.getInstance().buildUrl('booking_step', {
                'date': date,
                'time': null
            });

            this.model.set('start_date', date);

            if (!this.model.skipNavigationOnCalendar) {
                Backbone.history.navigate(url);
            }
        },

    });

});
